import { useMemo } from 'react';
import { getStatisticsDateRangeIso } from '../utils/calendar';
import { StatisticsVariant } from '../types/statistic-variant';
import { DateObject } from 'react-multi-date-picker';

export const useStatisticsDateRangeController = (
  dateRange: DateObject[] | null,
  variant: StatisticsVariant,
) => {
  const { from, to } = useMemo(
    () => getStatisticsDateRangeIso(dateRange, variant),
    [dateRange, variant],
  );

  return { from, to };
};
